import { Box, Fab, SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import { memo } from "react";


const FabButton = ({ items }) => {
    if (items.length === 0) {
        return null;
    } else if (items.length === 1) {
        const Icon=items[0].icon;
        return <Box sx={{ display: { xs: "block", md: "none" } }}>
            <Fab
                onClick={items[0].onClick} color="primary" aria-label={items[0].label}
                style={{ position: "fixed",color:"white", right: 32, bottom: 32, zIndex: 0 }}>
                <Icon/>
            </Fab></Box>
    } else if (items.length > 1) {
        return (
            <Box sx={{ display: { xs: "block", md: "none" } }}>
                <SpeedDial
                    ariaLabel="SpeedDial basic example"
                    sx={{ position: 'absolute', bottom: 16, right: 16 }}
                    icon={<SpeedDialIcon />}
                >                {items.map((action) =>{ 
                    const Icon=action.icon;
                    return (
                    <SpeedDialAction
                        key={action.name}
                        icon={<Icon/>}
                        onClick={action.onClick}
                        tooltipOpen
                        tooltipTitle={action.name}
                    />
                )})}
                </SpeedDial>
            </Box>)
    }

}

export default memo(FabButton);